// extracted by mini-css-extract-plugin
export default {"table":"StepTable_table__tvKG8","completed":"StepTable_completed__cis80","inProgress":"StepTable_inProgress__khK8e","pending":"StepTable_pending__Bk5Dd"};